import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api_createWishlist } from '~/backend/api_calls';
import { notifyError, notifyInfo } from '~/components/common/ToastMessages';

import { useSelector } from 'react-redux';
import closeFilters from '~/images/close-filters.svg';
import wishlist_icon from '~/images/wishlist-icon.svg';

const AddWishlist = ({ setShowAddWishlist }) => {
	const { t } = useTranslation();
	const [wishlistName, setWishlistName] = useState('');

	const closeAddToWishlist = useSelector(state => state.layoutReducer.showAddToWishlist);

	const handleFormSubmit = e => {
		e.preventDefault();

		if (wishlistName == null || wishlistName.length == 0) {
			notifyError(t('complete_all_fields'));
			return;
		}

		api_createWishlist(wishlistName)
			.then(json => {
				notifyInfo('Your new wishlist was created');
				setShowAddWishlist(false);
			})
			.catch(error => {
				notifyInfo(error);
				console.error(error);
			});
	};

	const closeWishlist = () => {
		setShowAddWishlist(false);
		if (!closeAddToWishlist) {
			document.body.classList.remove('overflow');
		}
	};

	return (
		<div className="modal">
			<div className="modal-content add-wish-modal">
				<button className="exit" type="button">
					<img src={closeFilters} alt="exit button" onClick={() => closeWishlist()} />
				</button>
				<h2 className="flex-col">
					<img className="desktop641" src={wishlist_icon} alt="wishlist icon" />
					{t('add_new_wishlist_title')}
				</h2>
				<div className="new-wishlist-addition add-new-wish wish-info">
					<p>{t('add_new_wishlist_description')}</p>
					<form method="post" className="add-new-wishlist-form" onSubmit={handleFormSubmit}>
						<div className="inputs">
							<div className={wishlistName ? 'form-input text-label actived' : 'form-input text-label'}>
								<input
									type="text"
									id="name-wishlist"
									value={wishlistName}
									onChange={e => setWishlistName(e.target.value)}
									required
									placeholder="name"
								/>
								<label htmlFor="name-wishlist">{t('wishlist_input_label')}</label>
							</div>
						</div>
						<button type="submit" className="submit arrow-button black-arrow-button wish-btn">
							{t('save_button')}
						</button>
					</form>
				</div>
			</div>
		</div>
	);
};

AddWishlist.propTypes = {
	setShowAddWishlist: PropTypes.any
};

export default AddWishlist;
